/**
 * @description 存放工具类函数
 * 必须为纯函数，非纯函数别放这里
 */
export const fitImgUrl = (url: string, width?: number, height?: number, format?: string, resizeMode?: string) => {
  if (!url || (!width && !height)) {
    return url
  }
  const resizeParams = [`m_${resizeMode ?? 'fill'}`]
  width && resizeParams.push(`w_${width}`)
  height && resizeParams.push(`h_${height}`)
  return `${url}?x-oss-process=image/resize,${resizeParams.join(',')}${format ? `/format,${format}` : ''}`
}

/**
 * @description 通过游戏库id 判断是否为csgo游戏
 */
export const isCSGO = (gamelibraryId: number) => {
  if (['prod', 'pre'].includes(process.env.BUILD_TYPE)) {
    return [15782938].includes(gamelibraryId)
  }
  return [2934].includes(gamelibraryId)
}

/**
 * 获取安装包名上的downloadId
 * @param setupName
 */
export const getDownloadIdFromSetupName = (setupName?: string) => {
  const clientName =
    setupName ||
    new URLSearchParams(new URL(localStorage.getItem('firstUrl') || window.location.href).search).get('SetupName')
  const result = /@(\S+)@/.exec(clientName ?? '')
  return result?.[1] ?? ''
}

/**
 * 获取安装包名上的3rdid
 */
export const get3rdIdFromSetupName = (setupName?: string) => {
  const clientName =
    setupName ||
    new URLSearchParams(new URL(localStorage.getItem('firstUrl') || window.location.href).search).get('SetupName')
  if (!clientName) {
    return ''
  }
  if (clientName) {
    const paramList = clientName.split('-')
    return paramList.find(f => f.startsWith('3rd'))?.replace('3rd', '') || ''
  }

  const result = /@(\S+)@/.exec(clientName ?? '')
  return result?.[1] ?? ''
}
